import { createApiSlice } from "@common";
import {
  CRUD_ASSET_CATEGORY,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addAssetCategory",
    method: "post",
    url: CRUD_ASSET_CATEGORY,
    stateKey: "message",
  },
  {
    name: "getAssetCategory",
    method: "get",
    url: CRUD_ASSET_CATEGORY,
    stateKey: "data",
  },
  {
    name: "updateAssetCategory",
    method: "put",
    url: CRUD_ASSET_CATEGORY,
    stateKey: "message",
  },
  {
    name: "updateStatusAssetCategory",
    method: "patch",
    url: CRUD_ASSET_CATEGORY,
    stateKey: "message",
  },
  {
    name: "deleteAssetCategory",
    method: "delete",
    url: CRUD_ASSET_CATEGORY,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    selectedData: {},
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "assetCategory",
  apiConfig,
  customReducers,
);
const assetCategorySlice = slice;
// Export the slice's reducer
export default assetCategorySlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addAssetCategory,
  getAssetCategory,
  updateAssetCategory,
  updateStatusAssetCategory,
  deleteAssetCategory,
} = thunks;

// Destructure and export actions 
export const { rowSelect } = actions;
